import React from 'react';
import {DataItem} from 'src/design-system';
import * as Yup from 'yup';
import {Text} from 'react-native';
import {Typography} from 'src/styles';
import {IDeveloperField} from 'dromo-uploader-react';
import HookFormSelectInput from 'src/hook-form-wrapper/select-input';

interface DisplayProps {
  value: string;
}

interface Props {
  name?: string;
}

export const skillMethodArray = [
  {
    value: 'trial_by_trial',
    title: 'Trial by Trial',
    label: 'Trial by Trial',
  },
  {
    value: 'task_analysis',
    label: 'Task Analysis',
    title: 'Task Analysis',
  },
];

export const Import = (
  key: string = 'method',
  prefix?: string,
): IDeveloperField => ({
  label: (prefix ? prefix + ' ' : '') + 'Collection Method',
  key,
  type: 'select',
  selectOptions: skillMethodArray,
  validators: [
    {
      validate: 'required',
    },
  ],
});

export const Value = (value: string) => {
  return skillMethodArray.find(item => item.value === value)?.label;
};

export const Display = ({value}: DisplayProps) => {
  return (
    <DataItem>
      <Text style={[Typography.H6]}>Collection Method</Text>
      <Text style={[Typography.P3]}>{Value(value)}</Text>
    </DataItem>
  );
};

export const Input = ({name}: Props) => {
  return (
    <HookFormSelectInput
      name={(name ? name + '.' : '') + 'method'}
      label={'Collection Method'}
      required={false}
      items={skillMethodArray}
    />
  );
};

export const validation = () =>
  Yup.string().required('Collection Method are required');

export default Input;
